<template>
    <SbsTooltip v-bind="tooltipData" class="sbs-videolayer-fullscreen-icon" ref="fullscreen">
        <div class="sbs-videolayer-fullscreen-icon__icon-wrapper" @click="handleClickFullscreenToggle">
            <InlineSvg class="sbs-videolayer-fullscreen-icon__icon" :src="fullscreenIcon"/>
        </div>
    </SbsTooltip>
</template>

<script>
import InlineSvg from 'vue-inline-svg';
import { toRaw } from 'vue';
import SbsTooltip from '../../tooltip/SbsTooltip.vue';
import fullscreenIcon from '../../../assets/svg/video-fullscreen-icon.svg';

export default {
    name: 'SbsVideoPlayerFullscreen',
    components: {
        SbsTooltip,
        InlineSvg,
    },
    inject: {
        videoPlayerComponent: { default: null },
    },
    data() {
        return {
            fullscreenToggleTooltipText: 'Во весь экран',
            fullscreenToggleComponent: null,
            fullscreenIcon,
        };
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
        tooltipData() {
            return {
                parentSelector: this.videoPlayerComponent.videoContainerSelector,
                offset: 0,
                position: 'top-end',
                width: this.fullscreenTooltipWidth,
                content: this.fullscreenToggleTooltipText,
            };
        },
        fullscreenTooltipWidth() {
            return this.player.isFullscreen()
                ? '260'
                : '118';
        },
    },
    methods: {
        handleClickFullscreenToggle() {
            if (this.player.isFullscreen()) {
                this.player.exitFullscreen();
            } else {
                this.player.requestFullscreen();
            }

            this.setFullscreenToggleTooltipText();
        },
        setFullscreenToggleTooltipText() {
            this.fullscreenToggleTooltipText = this.player.isFullscreen()
                ? 'Во весь экран'
                : 'Выход из полноэкранного режима';
        },
    },
    mounted() {
        this.player.controlBar.addChild('Component', {
            el: this.$refs.fullscreen.$el,
        });
    },
};
</script>

<style lang="scss">
@import "../styles/mixins.scss";

.sbs-videolayer-fullscreen-icon__icon-wrapper {
    @include video-icon-wrapper;
}

.sbs-videolayer-fullscreen-icon__icon {
    @include video-icon;
}
</style>
